import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-count",
  "use": "icon-count-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-count\"><path d=\"M0 0h1024v1024H0V0z\" fill=\"#202425\" opacity=\".01\" p-id=\"17034\" /><path d=\"M921.6 546.133333A443.733333 443.733333 0 1 1 477.866667 102.4v443.733333h443.733333z\" fill=\"#11AA66\" p-id=\"17035\" /><path d=\"M989.866667 477.866667A443.733333 443.733333 0 0 0 546.133333 34.133333v443.733334h443.733334z\" fill=\"#FFAA44\" p-id=\"17036\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol